

























import { Component, Vue } from 'vue-property-decorator'
import { Sensor } from '../store/sensor'
import Add from './Add.vue'
import Edit from './Edit.vue'
import { namespace } from 'vuex-class'

const sensorStore = namespace('sensor')

@Component({ components: { Add, Edit } })
export default class MainSensor extends Vue {
  @sensorStore.Action loadSensors!: () => void
  @sensorStore.Getter sensors!: Sensor[]
  created() {
    this.loadSensors()
  }
}
